import React, { useEffect, useState, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { Card, CardBody, Row, Col, Spinner, Button } from "reactstrap";
import { toast } from "react-toastify";
import axiosInstance from "../../../Axiosinstance";
import CompanyCard from "./CompanyCard";
import BranchUserTable from "./BranchUsertable";

const CompanyManagementDetails = () => {
  const { company_uid } = useParams();
  const [company, setCompany] = useState(null);
  const [branchUser, setBranchUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCompany = useCallback(async () => {
    if (!company_uid) return;
    setLoading(true);
    try {
      const { data } = await axiosInstance.get(
        `/api/getcompanydetails/${company_uid}`
      );
      if (data?.status) {
        setCompany(data.data || data.company);
        setBranchUser(data?.branchuser || data.company?.branchuser || null);
      } else {
        toast.error(data?.message || "Unable to fetch company details");
      }
    } catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.message || "Unable to fetch company details"
      );
    } finally {
      setLoading(false);
    }
  }, [company_uid]);

  useEffect(() => {
    fetchCompany();
  }, [fetchCompany]);

  return (
    <div className="page-content">
      <Row className="mb-3 align-items-center">
        <Col>
          <h4 className="mb-0">Company Details</h4>
        </Col>
        <Col xs="auto">
          <Button
            color="primary"
            outline
            tag={Link}
            to={`/companymanagement/${company_uid}/wallet`}
          >
            <i className="mdi mdi-wallet-outline me-1" />
            Wallet / History
          </Button>
        </Col>
      </Row>

      {loading ? (
        <Card>
          <CardBody className="d-flex align-items-center justify-content-center py-5">
            <Spinner color="primary" />
          </CardBody>
        </Card>
      ) : !company ? (
        <Card>
          <CardBody>
            <div className="text-muted">No company details available</div>
          </CardBody>
        </Card>
      ) : (
        <>
          <CompanyCard company={company} readOnly={true} />
          {branchUser && <BranchUserTable branchUser={branchUser} />}
        </>
      )}
    </div>
  );
};

export default CompanyManagementDetails;
